import { defineComponent as _defineComponent } from 'vue'
import { Trade, getPrimaryCcy, getSellCcy, getBuyCcy, formatHedgingInstrument } from 'ah-api-gateways';
import TradeDetailsModal from '../info/TradeDetailsModal.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { LockIcon } from 'ah-common-lib/src/icons/components';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeInfo',
  props: {
    trade: null,
    originalOnly: { type: [Boolean, String], default: false },
    hedgingProductLabel: { default: 'Type' }
  },
  setup(__props: any) {

const props = __props as { trade: Trade, originalOnly: boolean | string, hedgingProductLabel: string };



const shouldShowOriginalOnly = computed(() => {
  return props.originalOnly !== false;
});

const clientRate = computed(() => {
  return getPrimaryCcy(props.trade).clientRate;
});

const sellCcy = computed(() => {
  return getSellCcy(props.trade);
});

const buyCcy = computed(() => {
  return getBuyCcy(props.trade);
});

return { __sfc: true,props, shouldShowOriginalOnly, clientRate, sellCcy, buyCcy, formatHedgingInstrument, TradeDetailsModal, formatCurrencyValue, formatDate, SIMPLE_DATE_FORMAT, LockIcon }
}

})